import { Box, Divider } from "@mui/material"
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Attract } from "./attract/Index";



export const RealProperty = ({ opt }) => {
    const nav = useHistory()

    const optBtn = [
        { name: 'Attract', url: 'attract' },
        { name: 'Arrouse', url: 'arouse' },
        { name: 'Action', url: 'action' },
        { name: 'Retain', url: 'retain' },
        { name: 'Repeat', url: 'repeat' },
        { name: 'Refer', url: 'refer' },
    ]

    const stHandler = (url) => {
        nav.push(`sales_page?type=property&option=${url}`)
    }

    return (

        <Box>
            <Box display="flex" alignItems="center" gap={5} mt={2}>
                {
                    optBtn.map((v, k) => (
                        <Box display="flex" alignItems="center" flexDirection="column" onClick={() => stHandler(v.url)} key={k}>
                            <Box sx={{ cursor: "pointer", fontWeight: opt === v.url ? 550 : 500, color: opt === v.url ? "#009E6A" : "#000000" }} fontSize={15}>
                                {v.name}
                            </Box>
                            <Box sx={{ borderBottom: opt === v.url ? "solid #009E6A 2px" : false, color: opt === v.url ? "#000000" : "#E9E9E9", width: "100%" }} />
                        </Box>
                    ))
                }
            </Box>
            <Divider sx={{ width: "100%", my: 1 }} />
            {
                opt === 'attract' ?
                    <Attract />
                    : null
            }
        </Box>


    )
}
